{
  "#WWS_BASISARTIKELSTAND": {
    "DIALOGE": {
      "ABSENDEN": "Absenden",
      "SCHLIESSEN": "Schließen",
      "HINZUFUEGEN": "Hinzufügen",
      "KOMMENTAR": {
        "TITEL": "Kommentar",
        "SUB_TITEL": "Bitte gewünschten Kommentar einfügen:"
      },
      "ARTIKEL_HINZUFUEGEN": {
        "TITEL": "Weitere Artikel",
        "SUB_TITEL": "Artikel zum Hinzufügen auswählen:"
      }
    },
    "UEBERSICHT": {
      "STUECK": "Stück",
      "AKTIONEN": "Aktionen",
      "STOSS": "Stoß",
      "ANZAHL": "Anzahl",
      "EINHEIT": "Einheit",
      "KG": "kg",
      "BUTTON_HINZUFUEGEN": "+ Hinzufügen"
    }
  }
}
